import type { Product } from "@/types/product";
import { BEVERAGE_PRODUCTS } from "@/data/beverages";
import { BISPC_PRODUCTS } from "@/data/bispc";
import { CHOCOBARS_PRODUCTS } from "@/data/chocobars";
import { COOKING_OIL_PRODUCTS } from "@/data/cookingoils";
import { FOOD_PRODUCTS } from "@/data/food";
import { HOMECARE_PRODUCTS } from "@/data/homecare";
import { INDIAN_GROCERY_PRODUCTS } from "@/data/indiangroceries";
import { JAMS_SPREADS_PRODUCTS } from "@/data/jamsspreads";
import { PERFUME_PRODUCTS } from "@/data/perfumes";
import { PERSONAL_CARE_PRODUCTS } from "@/data/personalcare";
import { SNACK_PRODUCTS } from "@/data/snacks";
import { SWEETS_CHOCOLATES_PRODUCTS } from "@/data/sweetschocolates";
import { UNCATEGORIZED_PRODUCTS } from "@/data/uncategorized";

export type { Product };

/** Static catalog used for seed export only. Runtime storefront loads from the API. */
export const PRODUCTS: Product[] = [
  ...BEVERAGE_PRODUCTS,
  ...BISPC_PRODUCTS,
  ...CHOCOBARS_PRODUCTS,
  ...COOKING_OIL_PRODUCTS,
  ...FOOD_PRODUCTS,
  ...HOMECARE_PRODUCTS,
  ...INDIAN_GROCERY_PRODUCTS,
  ...JAMS_SPREADS_PRODUCTS,
  ...PERFUME_PRODUCTS,
  ...PERSONAL_CARE_PRODUCTS,
  ...SNACK_PRODUCTS,
  ...SWEETS_CHOCOLATES_PRODUCTS,
  ...UNCATEGORIZED_PRODUCTS,
];

export const formatPrice = (price: number): string => {
  if (!price || price <= 0) return "Enquire";
  return new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(price);
};

export const getRelatedProducts = (products: Product[], product: Product, limit = 4): Product[] =>
  products.filter((p) => p.categorySlug === product.categorySlug && p.id !== product.id).slice(0, limit);
